import axios from "axios";

export const httpClient = axios.create({
    baseURL: import.meta.env.VITE_BASE_API_URL,
    headers: {
        "x-api-key": "dl1daxdfak39afdak3aa",
    },
})
